import API from '../../utils/api';
import { AGENT_SERVICE_ENDPOINT_URL, FEED_TYPES } from '../../constants/defaultValues';
import { PRODUCER_STATUSES_CHANGED } from './types';

export const fetchProducerStatuses = () => async dispatch => {
    try {
        const response = await API.get(`${AGENT_SERVICE_ENDPOINT_URL}/settings`);
        const { info, items } = response.data;

        if (!info.success) {
            return;
        }

        const isPreMatchProducerDown =
            items.find(producer => producer.key === FEED_TYPES.preMatch)?.value === 'DOWN';
        const isLiveProducerDown =
            items.find(producer => producer.key === FEED_TYPES.live)?.value === 'DOWN';

        const producerStatuses = {
            isPreMatchDown: isPreMatchProducerDown,
            isLiveDown: isLiveProducerDown,
        };

        dispatch({
            type: PRODUCER_STATUSES_CHANGED,
            payload: producerStatuses,
        });
    } catch (error) {
        console.error(error);
    }
};
